module.exports = __webpack_public_path__ + "static/media/social1.afb55017.png";